import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { KpiService } from "../kpi/kpi.service";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LaunchDarklyService {
  ldClient;
  user;
  flags;
  flagChange: Subject<any> = new Subject<any>();

  constructor(public kpiService: KpiService) {
    const LDClient = require("launchdarkly-js-client-sdk");
    this.kpiService.getUserInfo().subscribe(
      (data) => {
        this.flags = {};
        this.user = {
          key: data.userId,
          custom: {
            organizationId: data.organizationId,
            licenseLevel: data.sz_tier,
            role: data.role,
          },
        };
        this.ldClient = LDClient.initialize(
          environment.launchDarklyClientSideId,
          this.user
        );
        this.ldClient.on("change", (flags: any) => {
          for (let flag in flags) {
            this.flags[flag] = flags[flag].current;
          }
          this.flagChange.next(this.flags);
        });
        this.ldClient.on("ready", () => {
          this.setFlags();
        });
      },
      (error) => {
        console.error(error);
      }
    );
  }

  getFlag(flagName: FlagNames) {
    let flag = this.flags[flagName];
    if (flag == undefined) {
      this.flags[flagName] = false;
      flag = false;
    }
    return flag;
  }

  setFlags() {
    this.flags = this.ldClient.allFlags();
    this.flagChange.next(this.flags);
  }

  track(name) {
    this.ldClient.track(name);
  }

  waitForInitialization() {
    return this.ldClient.waitForInitialization();
  }
}

export type FlagNames =
  | "our-schools-nav-link"
  | "mosaic-ui-school-profile-real-time"
  | "mosaic-ui-new-product-logos"
  | "mosaic-ui-show-metric-editor"
  | "mosaic-ui-show-student-groups";
